import { render, staticRenderFns } from "./UserConsumption.vue?vue&type=template&id=6eca2369&scoped=true"
import script from "./UserConsumption.vue?vue&type=script&lang=js"
export * from "./UserConsumption.vue?vue&type=script&lang=js"
import style0 from "./UserConsumption.vue?vue&type=style&index=0&id=6eca2369&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca2369",
  null
  
)

export default component.exports